export default __webpack_public_path__ + "static/media/avatar_17.1c0c389e.png";